import React from "react";
import { Link } from "react-router-dom";

/**
 * AppHeader — Centered My Fleet logo, prominently displayed at the top of every page.
 *
 * Uses the same official logo file as the app icon (public/logo-myfleet.png).
 * Responsive sizing via CSS classes (kept aspect ratio 3:1, never distorted).
 *
 * Variants:
 * - "dark"  (default) — for light backgrounds (uses dark logo)
 * - "light" — for dark backgrounds (uses white logo)
 *
 * Options:
 * - background: "transparent" (default), "brand" (deep navy), "surface" (white card)
 * - href: if provided, wraps the logo in a Link to that route (defaults to "/")
 * - clickable: false to disable link wrapping
 */
export function AppHeader({
  variant = "dark",
  background = "transparent",
  clickable = true,
  href = "/",
  testID = "app-header",
}) {
  const src = variant === "light" ? "/logo-myfleet-white.png" : "/logo-myfleet.png";

  const wrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    paddingTop: "calc(20px + env(safe-area-inset-top, 0px))",
    paddingBottom: 18,
    paddingLeft: 20,
    paddingRight: 20,
    background:
      background === "brand"
        ? "var(--mf-brand)"
        : background === "surface"
          ? "var(--mf-bg-card)"
          : "transparent",
    borderBottom:
      background === "transparent" || background === "surface"
        ? "1px solid var(--mf-divider)"
        : "none",
  };

  const img = (
    <img
      src={src}
      alt="My Fleet"
      className="mf-app-header-logo"
      draggable={false}
      data-testid="app-header-logo"
    />
  );

  return (
    <header data-testid={testID} style={wrapperStyle}>
      {clickable ? (
        <Link
          to={href}
          data-testid="app-header-link"
          style={{ display: "inline-flex", textDecoration: "none", lineHeight: 0 }}
          aria-label="My Fleet — accueil"
        >
          {img}
        </Link>
      ) : (
        img
      )}
    </header>
  );
}
